import type { AuthErrorCode } from '@volee/auth'

// La traduzione italiana, tipizzata sul contratto: un codice senza frase non compila.
export const IT_AUTH_ERRORS: Record<AuthErrorCode, string> = {
  invalid_credentials: 'Email o password non corretti.',
  user_not_found: 'Email o password non corretti.',
  user_not_confirmed: 'Email o password non corretti.',

  password_rejected: 'Questa password non rispetta i requisiti.',
  code_mismatch: 'Il codice non è corretto.',
  code_expired: 'Il codice è scaduto. Richiedine uno nuovo.',
  rate_limited: 'Troppi tentativi. Aspetta qualche minuto e riprova.',
  password_reset_required: 'Questa password va reimpostata prima di poter accedere.',
  challenge_expired: 'È passato troppo tempo. Ricomincia dalla pagina di accesso.',
  invalid_parameter: 'Alcuni dati inseriti non sono validi.',
  challenge_unsupported:
    'Questo account richiede un passaggio che l’app non gestisce. Chiedi a un amministratore.',
  scope_insufficient: 'Questa sessione non può cambiare la password. Esci e accedi di nuovo.',
  idp_request_failed: 'Il servizio di accesso non ha risposto. Riprova fra poco.',

  state_mismatch: 'Non è stato possibile verificare l’accesso. Riprova.',
  verifier_missing: 'Non è stato possibile verificare l’accesso. Riprova.',
  callback_error: 'Non è stato possibile completare l’accesso. Riprova.',
  token_request_failed: 'Non è stato possibile completare l’accesso. Riprova.',
  id_token_missing: 'Non è stato possibile completare l’accesso. Riprova.',
  refresh_failed: 'La tua sessione è terminata. Accedi di nuovo.',
  no_refresh_token: 'La tua sessione è terminata. Accedi di nuovo.',
  crypto_unavailable:
    'Questo browser non può accedere in modo sicuro. Aggiornalo o usane un altro.',
  delegation_unavailable:
    'Su questo telefono non si può ancora aggiungere l’account di tuo figlio. Riprova più tardi.',
  delegation_refused: 'Non è stato possibile aggiungere l’account di tuo figlio. Riprova.',
}
